import React, { useState, useEffect } from "react";
import CommentBox from "../CommentBox";
import Comments from "../Comments";

import { useFirestore } from "react-redux-firebase";

import { v4 } from "uuid";
import "../../../css/contact-detail.css";
import "../../forms/forms.css";
import styled from "styled-components";

import MainView from "./MainView";
import EditView from "./EditView";
import FormPreview from "./customer-forms/preview/FormPreview";
import FormsList from "./FormsList";

import { AnimatePresence } from "framer-motion";
import { contactTypeArray } from "./constants";

export const colors = {
  "purchase agreement": "#798b79",
  "final invoice": "#3398B8",
  custom: "#9999CC",
};

const Container = styled.div`
  @media screen and (min-width: 900px) {
    display: flex;
    justify-content: center;
    justify-content: space-between;
  }
`;

const LeftView = styled.div`
  @media screen and (min-width: 900px) {
    width: 49.5%;
  }
`;

const RightView = styled.div`
  @media screen and (min-width: 900px) {
    width: 49.5%;
  }
`

const Details = styled.div`
  background: white;
  padding: 20px;
  width: 100%;
  box-shadow: 7px 7px 10px rgb(0 0 0 / 7%);
`;

function ContactDetail(props) {
  const firestore = useFirestore();

  const { contact, comments, items, editing, onClickingDelete, documents } =
    props;

  const contactComments = comments.filter((c) => c.contactID === contact.id);

  const [storedContact, setStoredContact] = useState(contact);
  const [storedDocuments, setStoredDocuments] = useState(documents);

  const handleStoredContact = (key, value) => {
    setStoredContact({ ...storedContact, [key]: value });
  };
  const [storedContactComments, setStoredContactComments] =
    useState(contactComments);

  const editContact = (e) => {
    const value = e.target.value;
    const key = e.target.name;

    handleStoredContact(key, value);

    return firestore.update(
      { collection: "contacts", doc: contact.id },
      {
        [key]: value,
      }
    );
  };

  useEffect(() => {
    const propertiesToUpdate = {
      contactType: storedContact.contactType,
      deliveryCity: storedContact.deliveryCity,
      deliveryCountry: storedContact.deliveryCountry,
      deliveryRegion: storedContact.deliveryRegion,
      deliveryStreetAddress: storedContact.deliveryStreetAddress,
      deliveryZipCode: storedContact.deliveryZipCode,
      description: storedContact.description,
      email: storedContact.email,
      firstName: storedContact.firstName,
      lastName: storedContact.lastName,
      mailingCity: storedContact.mailingCity,
      mailingCountry: storedContact.mailingCountry,
      mailingRegion: storedContact.mailingRegion,
      mailingStreetAddress: storedContact.mailingStreetAddress,
      mailingZipCode: storedContact.mailingZipCode,
      phoneNumber: storedContact.phoneNumber,
      dueDate: storedContact.dueDate ? storedContact.dueDate : "",
    };
    return firestore.update(
      { collection: "contacts", doc: contact.id },
      propertiesToUpdate
    );
  }, [storedContact, firestore, contact.id]);

  const handleClickContactType = () => {
    let typeIndex = contactTypeArray.indexOf(storedContact.contactType);

    handleStoredContact(
      "contactType",
      contactTypeArray[(typeIndex + 1) % contactTypeArray.length]
    );
  };

  const handleAddingNewComment = (comment) => {
    const newComment = {
      id: v4(),
      contactID: contact.id,
      contactName: contact.firstName + " " + contact.lastName,
      commentBody: comment,
      createDate: Date.now(),
    };
    setStoredContactComments([...storedContactComments, newComment]);
    return firestore.collection("comments").add({
      contactID: contact.id,
      contactName: contact.firstName + " " + contact.lastName,
      commentBody: comment,
      createDate: Date.now(),
    });
  };

  const deleteComment = (id) => {
    firestore.delete({ collection: "comments", doc: id });

    let index = storedContactComments.findIndex((e) => e.id === id);
    let newArray = storedContactComments;
    newArray.splice(index, 1);
    setStoredContactComments([...newArray]);
  };

  const sortCommentByDate = (array) => {
    array.sort((a, b) => b.createDate - a.createDate);
  };

  sortCommentByDate(storedContactComments);

  let view = null;

  if (editing) {
    view = (
      <EditView
        storedContact={storedContact}
        handleClickContactType={handleClickContactType}
        handleStoredContact={handleStoredContact}
      />
    );
  } else {
    view = (
      <MainView
        storedContact={storedContact}
        handleClickContactType={handleClickContactType}
      />
    );
  }

  let openDocs = storedDocuments.filter((e) => e.open);

  return (
    <>
      <br />
      <Container>
        <LeftView>
          <Details>{view}</Details>
          <div>
            <FormsList
              previousItems={items}
              editContact={editContact}
              contact={storedContact}
              storedDocuments={storedDocuments}
              setStoredDocuments={setStoredDocuments}
              colors={colors}
            />
          </div>
        </LeftView>
        <RightView>
          <AnimatePresence>
            {openDocs.map((doc, i) => (
              <FormPreview
                value={storedContact}
                document={doc}
                key={doc.id}
                colors={colors}
              />
            ))}
          </AnimatePresence>
        </RightView>
      </Container>
      <div className="mt-4">
        <CommentBox
          onSubmitNewComment={(text) => handleAddingNewComment(text)}
        />
        {storedContactComments.map((comment) => (
          <Comments
            key={comment.id}
            comment={comment}
            deleteComment={deleteComment}
          />
        ))}
        <br />

        <div className="float-right">
          <button
            className="delete-contact"
            onClick={() => onClickingDelete(contact.id)}
          >
            delete contact
          </button>
        </div>
      </div>
    </>
  );
}

export default ContactDetail;
